<div class="row mt-3">
  <div class="col text-muted">
    <span>{{ key | transloco }}</span>
  </div>
</div>
<div class="row">
  <div class="col loren-value">
    {{ value || ("key_value.information_not_available" | transloco) }}
  </div>
</div>
